//=> Import React
import React from "react";

//=> Import plugins
import { graphql, useStaticQuery } from "gatsby";
import { AiOutlineClockCircle } from "react-icons/ai";
import { convertDate } from "../../utils/convertDate"

//=> Import fonction
import { color } from "../../utils/color";

//=> Import component
import Divider from "../Divider";

//=> Import Styles
import {
  title,
  eventContainer,
  eventItem,
  dateContainer,
  image,
  description,
  eventTitle,
  time,
  icon,
  dayCss,
  dateCss
} from "./styles.module.scss";

const Workshop = ({ setInfoEvent, setModalIsOpen, modalIsOpen }) => {
  // Query Event
  const data = useStaticQuery(graphql`
    query {
      allStrapiWorkshop {
        edges {
          node {
            color
            date
            description
            name
            slug
            time
            feedback {
              alternativeText
              file {
                url
              }
            }
            image {
              alternativeText
              file {
                url
              }
            }
            done
          }
        }
      }
    }
  `);

  // Je filtre les events terminer et ceux pas encore terminer
  const WorkshopDone = data.allStrapiWorkshop.edges.filter(
    (elem) => elem.node.done
  );
  const WorkshopInProgress = data.allStrapiWorkshop.edges.filter(
    (elem) => !elem.node.done
  );

  // => Filtre l'event cliqué
  const eventToDisplay = (slug) => {
    return data.allStrapiWorkshop.edges.filter(
      (elem) => elem.node.slug === slug
    );
  };
  // => Au clic ouvre la modal avec les info de l'event cliqué
  const onClickEvent = (slug) => {
    setInfoEvent(eventToDisplay(slug));
    setModalIsOpen(!modalIsOpen);
  };

  const handlerOnKeyDown = (e, slug) => {
    console.log(e)
    if (e.keyCode === 13) {
      console.log(e)

      setInfoEvent(eventToDisplay(slug));
      setModalIsOpen(!modalIsOpen);
    }
  }

  return (
    <div>
      {/* Prochain event*/}
      <h3 className={title}>Les prochains ateliers</h3>
      <Divider />
      <div className={eventContainer}>
        {WorkshopInProgress.length > 0 ? (
          WorkshopInProgress.map((event) => (
            <div>
              <article
                key={event.node.slug}
                className={eventItem}
                tabIndex={0}
                onClick={() => {
                  onClickEvent(event.node.slug);
                }}
                onKeyDown={(e) => {
                  handlerOnKeyDown(e, event.node.slug)
                }}
              >
                <div className={dateContainer}>
                  <div className={dayCss}>{convertDate(event.node.date)[0].slice(0, 3)}</div>
                  <div className={dateCss}>{convertDate(event.node.date)[1]}</div>
                </div>
                <div
                  className={image}
                  style={{ backgroundImage: `url(${event.node.image.file.url})` }}
                  title={event.node.name}
                  aria-label={event.node.name}
                />
                <div
                  className={description}
                  style={{ backgroundColor: color(event.node.color) }}
                >
                  <h6 className={eventTitle}>{event.node.name}</h6>
                  <div className={time}>
                    {" "}
                    <AiOutlineClockCircle className={icon} />{" "}
                    {`Durée: ${event.node.time}h`}
                  </div>
                </div>
              </article>
            </div>

          ))
        ) : (
          <h5 style={{ margin: "40px 0 40px 0" }}>
            {" "}
            ☹ Pas d'atelier prévu pour l'instant ☹
          </h5>
        )}
      </div>
      {/* Prochain terminées*/}
      <h3 className={title}>Les ateliers terminées</h3>
      <Divider />
      <div className={eventContainer}>
        {WorkshopDone.length > 0 ? (
          WorkshopDone.map((event) => (
            <article
              key={event.node.slug}
              className={eventItem}
              tabIndex={0}
              onClick={() => {
                onClickEvent(event.node.slug);
              }}
              onKeyDown={(e) => {
                handlerOnKeyDown(e, event.node.slug)
              }}
            >
              <div className={dateContainer}>
                <div className={dayCss}>{convertDate(event.node.date)[0].slice(0, 3)}</div>
                <div className={dateCss}>{convertDate(event.node.date)[1]}</div>
              </div>
              <div
                className={image}
                style={{ backgroundImage: `url(${event.node.image.file.url})` }}
                title={event.node.image.alternativeText}
                aria-label={event.node.image.alternativeText}
              />
              <div
                className={description}
                style={{ backgroundColor: color(event.node.color) }}
              >
                <h6 className={eventTitle}>{event.node.name}</h6>
                <div className={time}>
                  {" "}
                  <AiOutlineClockCircle className={icon} />{" "}
                  {`Durée: ${event.node.time}h`}
                </div>
              </div>
            </article>
          ))
        ) : (
          <h5 style={{ margin: "40px 0 40px 0" }}>
            {" "}
            🛠 Pas encore d'évenement dans cette section 🛠
          </h5>
        )}
      </div>
    </div>
  );
};

export default Workshop;
